module.exports = __webpack_public_path__ + "img/wfqwt.b61d907.png";